"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PersonSummary = exports.PersonSummaryDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var content_1 = require("../elements/content");
var html_1 = require("../elements/html");
var image_bubble_1 = require("../elements/image-bubble");
var icons_1 = require("../icons");
var Pin = icons_1.Icons.Pin;
exports.PersonSummaryDefaultProps = {
  entity: {
    id: null,
    name: 'Unknown',
    slug: 'unknown',
    organisation: null,
    positions: []
  },
  pad: false
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    ", "\n  "], ["\n    display: flex;\n    ", "\n  "])), function (props) {
    return props.pad && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      padding: ", " ", ";\n    "], ["\n      padding: ", " ", ";\n    "])), theme_1.theme.UNIT(6), theme_1.theme.UNIT(4));
  })
});
var NameStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", ";\n    font-family: ", ";\n    font-weight: 400;\n    margin-top: 0;\n    margin-bottom: 0.35em;\n  "], ["\n    ", ";\n    font-family: ", ";\n    font-weight: 400;\n    margin-top: 0;\n    margin-bottom: 0.35em;\n  "])), theme_1.theme.RESPONSIVE_FONT_SIZE('small'), theme_1.theme.FONT('sans')),
  landscape: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-bottom: 0.65em;\n  "], ["\n    margin-bottom: 0.65em;\n  "])))
});
var PositionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", ";\n    font-family: ", ";\n    font-weight: 300;\n    color: ", ";\n    margin-top: 0;\n    margin-bottom: 0.35em;\n  "], ["\n    ", ";\n    font-family: ", ";\n    font-weight: 300;\n    color: ", ";\n    margin-top: 0;\n    margin-bottom: 0.35em;\n  "])), theme_1.theme.RESPONSIVE_FONT_SIZE('very-small'), theme_1.theme.FONT('sans'), theme_1.theme.COLOR('text')),
  landscape: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    margin-bottom: 0.65em;\n  "], ["\n    margin-bottom: 0.65em;\n  "])))
});
var ProfileAndInfoStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n  "]))),
  landscape: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    flex-direction: row;\n  "], ["\n    flex-direction: row;\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    flex-direction: column;\n  "], ["\n    flex-direction: column;\n  "]))),
  desktop: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    flex-direction: row;\n  "], ["\n    flex-direction: row;\n  "])))
});
var LocationStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    ", ";\n    font-family: ", ";\n    color: ", ";\n    display: flex;\n    font-weight: 300;\n    align-items: center;\n  "], ["\n    ", ";\n    font-family: ", ";\n    color: ", ";\n    display: flex;\n    font-weight: 300;\n    align-items: center;\n  "])), theme_1.theme.RESPONSIVE_FONT_SIZE('very-small'), theme_1.theme.FONT('sans'), theme_1.theme.COLOR('text-subtle'))
});
var LocationIconStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    ", ";\n    width: 20px;\n    height: 20px;\n    margin-right: ", ";\n  "], ["\n    ", ";\n    width: 20px;\n    height: 20px;\n    margin-right: ", ";\n  "])), theme_1.theme.FILL('yellow'), theme_1.theme.UNIT(2))
});
var PhotoAndInfoStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "]))),
  landscape: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    width: 47%;\n  "], ["\n    width: 47%;\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    width: auto;\n  "], ["\n    width: auto;\n  "]))),
  desktop: (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    width: 47%;\n  "], ["\n    width: 47%;\n  "])))
});
var InfoStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    box-sizing: border-box;\n    padding-right: ", ";\n    padding-left: ", ";\n    padding-top: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    box-sizing: border-box;\n    padding-right: ", ";\n    padding-left: ", ";\n    padding-top: ", ";\n  "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(4), theme_1.theme.UNIT(1)),
  landscape: (0, styled_components_1.css)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    padding-top: ", ";\n  "], ["\n    padding-top: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var DetailsColumnStyles = (0, styled_components_1.css)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n  ", ";\n  padding-top: ", ";\n  padding-left: ", ";\n  width: 53%;\n"], ["\n  ", ";\n  padding-top: ", ";\n  padding-left: ", ";\n  width: 53%;\n"])), theme_1.theme.DOT_BG('v'), theme_1.theme.UNIT(4), theme_1.theme.UNIT(4));
/* For tablet, we want to revert to layout the columns out in rows,
as the layout space is very tight given that these are PRESENTED in two columns */
var ContentStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    box-sizing: border-box;\n    padding-top: ", ";\n\n    ul li,\n    ol li {\n      margin-bottom: 0.75em;\n    }\n\n  "], ["\n    box-sizing: border-box;\n    padding-top: ", ";\n\n    ul li,\n    ol li {\n      margin-bottom: 0.75em;\n    }\n\n  "])), theme_1.theme.UNIT(6)),
  landscape: DetailsColumnStyles,
  tablet: (0, styled_components_1.css)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    background: none;\n    width: auto;\n    padding-top: ", ";\n  "], ["\n    background: none;\n    width: auto;\n    padding-top: ", ";\n  "])), theme_1.theme.UNIT(10)),
  desktop: DetailsColumnStyles
});
var ProfileLinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Name: styled_components_1.default.h1(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), NameStyles),
  Position: styled_components_1.default.h2(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), PositionStyles),
  ProfileAndInfo: styled_components_1.default.div(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), ProfileAndInfoStyles),
  Info: styled_components_1.default.div(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), InfoStyles),
  Location: styled_components_1.default.div(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), LocationStyles),
  LocationIcon: (0, styled_components_1.default)(Pin)(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), LocationIconStyles),
  Content: (0, styled_components_1.default)(content_1.Content)(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  PhotoAndInfo: styled_components_1.default.div(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), PhotoAndInfoStyles)
};
var PersonSummary = function (props) {
  var className = props.className,
    entity = props.entity,
    pad = props.pad;
  return React.createElement(My.Container, {
    pad: pad,
    className: className
  }, React.createElement(My.ProfileAndInfo, null, React.createElement(My.PhotoAndInfo, null, React.createElement(image_bubble_1.ImageBubble, {
    responsive: true,
    image: entity.photo
  }), React.createElement(My.Info, null, React.createElement(My.Name, null, entity.name), entity.position && React.createElement(My.Position, null, entity.position), entity.location && React.createElement(My.Location, null, React.createElement(My.LocationIcon, null), entity.location))), React.createElement(My.Content, {
    sans: true,
    verySmall: true
  }, React.createElement(html_1.HTML, {
    text: entity.bio && entity.bio.html || entity.skills
  }))));
};
exports.PersonSummary = PersonSummary;
exports.PersonSummary.defaultProps = exports.PersonSummaryDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31;